class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);

document.querySelector('[data-header-search-open]')?.addEventListener('click', (event) => {
  event.preventDefault();
  document.body.classList.add('no-scroll');
  document.querySelector('.custom-search__container')?.classList.add('custom-search__container--active');
  document.querySelector('main-search input[type="search"]')?.focus();
});

document.querySelectorAll('[data-custom-search-close]').forEach((closeBtn) => {
  closeBtn.addEventListener('click', (event) => {
    event.preventDefault();
    document.body.classList.remove('no-scroll');
    document.querySelector('.custom-search__container')?.classList.remove('custom-search__container--active');
  });
});

// document.querySelector('#custom-search-button').addEventListener('click', () => {
//   document.querySelector('[data-header-search-open]').click();
// });
